export default __webpack_public_path__ + "static/workflow-automation-15f674ba98a9feeb4a3c7ed3c80200e4.png";